define('views/shared/error/error',["backbone",
        "text!views/shared/error/error.html",
], function (Backbone, ErrorTemplate) {
    "use strict";

    return Backbone.View.extend({
        initialize: function (options) {
            options = options || {};

            this.errType = options.errType;
            var that = this;
            switch (this.errType)
            {
                case pf.enums.errorEnum.NotAuthorized:
                    that.ErrorMessage = "You are not authorized, buddy!";
                    break;
                default:
                    that.ErrorMessage = "Not sure why, but you are in an error state";
                    break;
            }
        },
        render: function () {
            if (this != null && this.$el[0].innerHTML == "")
                this.$el.html(ErrorTemplate);

            return this;
        },
        close: function () { }
    });
});
